// @ts-nocheck — verbatim port from xop-edge-staff. See src/crm/README.md.
import { TableCell, TableSortLabel } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import type { SortDir } from "./table-query.js";

export interface SortableHeaderProps {
  /** Server column key — must appear in the controller's `sortable_columns`. */
  column: string;
  label: string;
  /** Currently active column, from `useTableQuery`. */
  sort: string;
  dir: SortDir;
  onSort: (column: string) => void;
  align?: "left" | "right" | "center";
  sx?: SxProps<Theme>;
}

/**
 * A sortable column header. Generalises the inline `SortHeader` helper that
 * `customer-invoices-table.tsx` proved on the Billing tab: MUI's
 * `<TableSortLabel>` inside a `<TableCell sortDirection>`, which gives the
 * arrow affordance, the `aria-sort` announcement and keyboard activation for
 * free.
 *
 * There is deliberately no "unsorted" third click state — the server always
 * has SOME order, so "no sort" is not a state the list can actually be in.
 */
export function SortableHeader({
  column, label, sort, dir, onSort, align = "left", sx,
}: SortableHeaderProps) {
  const active = sort === column;
  return (
    <TableCell
      align={align}
      sortDirection={active ? dir : false}
      {...(sx ? { sx } : {})}
    >
      <TableSortLabel
        active={active}
        direction={active ? dir : "asc"}
        onClick={() => onSort(column)}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );
}
